module.exports = __webpack_public_path__ + "img/Hybrid-D-7.7c241284.jpg";